/* eslint-disable no-param-reassign */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

/**
 * Store factory
 */
export default new Vuex.Store({});
